<template>
  <v-dialog v-model="dialog.display" max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("distributors.transfers.details.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 pt-4">
        <v-container fluid grid-list-md v-if="!_.isEmpty(transfer)">
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-calendar-blank-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.created.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $moment(transfer.created).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-if="$auth.check(['ROLE_ADMIN'])">
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-account-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("commons.fields.account.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      $objectPath.get(transfer, "application.user.username")
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="3" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-identifier</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.identifier.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="9" class="py-2">
              <div class="text-right">
                <span class="text-body-2">{{ transfer.identifier }}</span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-id-card</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.source_distributor_id.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{ transfer.source_dist_id }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-id-card</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.destination_distributor_id.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    transfer.destination_dist_id
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="5" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-clipboard-account-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.distributor_name.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="7" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    transfer.destination_dist_name
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-cash</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.amount.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">
                    {{ $utils.numberformat(transfer.amount, lang) }}</span
                  >
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-radiobox-blank</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.status.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip
                  class="table-chips text-body-2"
                  color="success"
                  v-if="transfer.status === 'SUCCESS'"
                >
                  <span>{{
                    $t(`commons.fields.status.${transfer.status}`)
                  }}</span>
                </v-chip>
                <v-chip
                  class="table-chips text-body-2"
                  color="primary"
                  v-else-if="transfer.status === 'TRANSIENT'"
                >
                  <span>{{
                    $t(`commons.fields.status.${transfer.status}`)
                  }}</span>
                </v-chip>
                <v-chip class="table-chips text-body-2" color="error" v-else>
                  <span>{{
                    $t(`commons.fields.status.${transfer.status}`)
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-if="transfer.errors">
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="3" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-alert-circle-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("commons.fields.errors.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="9" class="py-2">
                <div class="text-right">
                  <span class="text-body-2">{{
                    transfer.errors.code + ": " + transfer.errors.description
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="12" class="py-2">
              <div class="text-right">
                <span class="text-body-2">{{ transfer.description }}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  created() {
    this.lang = this.$utils.setLocaleToBCP47(this.$i18n.locale);
  },
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          display: false,
        };
      },
    },
    transfer: {
      default: function() {
        return {};
      },
    },
  },
  data: () => ({
    lang: null,
  }),
  methods: {},
};
</script>
